import { ApiClient } from "src/api";

export async function end(
  apiClient: ApiClient,
  conversationId: number
): Promise<void> {
  apiClient.post(`/isxs/conversation/${conversationId}/end/`);
}
